import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import DropZoneFiles from "../../../../../components/dropzoneFiles/index";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { URL_API } from "config";
import MDButton from "components/MDButton";
import { CrudCooperatedContext } from "context/CrudCooperatedContext";
import { toast } from "react-toastify";
import { useAuthContext } from "context/AuthContext";

export default function CooperatedDocumentsSecond() {
  const [allDocuments, setAllDocuments] = useState(false);

  const { uuid } = useParams();
  const { documents } = useContext(CrudCooperatedContext);
  const { user } = useAuthContext();

  const documentFiles = {
    file_name: "",
    colab_id: "",
    type: "",
  };

  const navigate = useNavigate();

  const getAllDocuments = async () => {
    try {
      const res = await axios.get(URL_API + `/user-documents/${uuid}?all=true`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      });

      setAllDocuments(res.data.documents);
    } catch (error) {
      return 500;
    }
  }

  useEffect(() => {
    getAllDocuments();
    // eslint-disable-next-line
  }, [documents])

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Documentos</MDTypography>

        <MDBox style={{ display: 'flex', justifyContent: 'space-between' }}>
          <MDTypography variant="button" color="title">
            <MDTypography variant="button" color="text">
              <strong>Tamanho max. para arquivo:{' '}</strong>
            </MDTypography>
            1 MB <strong style={{ color: 'red' }} >*</strong>
          </MDTypography>

          <MDTypography variant="button" color="title">
            <span>
              <MDTypography variant="button" color="text">
                <strong>Tipos de arquivos:{' '}</strong>
              </MDTypography>
              .png, .jpg, .jpeg, .pdf
            </span>
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox mt={1.625}>
        <DropZoneFiles
          name="file_name"
          required
          value={documentFiles.file_name}
          accept={".png, .jpg, .jpeg, .pdf"}
          typeFile="identification_document"
          NameDescription={"Adicionar Frente e Verso do Documento de Identificação"}
        />
        <DropZoneFiles
          name="file_name"
          value={documentFiles.file_name}
          accept={".png, .jpg, .jpeg, .pdf"}
          typeFile="marital_status"
          NameDescription={"Adicionar Comprovante Estado Civil"}
        />
        <DropZoneFiles
          name="file_name"
          required
          value={documentFiles.file_name}
          accept={".png, .jpg, .jpeg, .pdf"}
          typeFile="address_proof"
          NameDescription={"Adicionar Comprovante de Residência"}
        />
        <DropZoneFiles
          name="file_name"
          required
          value={documentFiles.file_name}
          accept={".png, .jpg, .jpeg, .pdf"}
          typeFile="income_proof"
          NameDescription={"Adicionar Comprovante de Renda"}
        />
        <DropZoneFiles
          name="file_name"
          required
          value={documentFiles.file_name}
          accept={".png, .jpg, .jpeg, .pdf"}
          typeFile="subscription_card"
          NameDescription={"Adicionar Ficha de Interesse"}
        />
      </MDBox>

      <MDBox
        mt={2}
        width="100%"
        display="flex"
        justifyContent="space-between"
      >
        <MDButton
          variant="gradient"
          color="light"
          onClick={() => {
            if (user.profile !== 99) {
              navigate(`/admin/colaboradores/atualizar/${uuid}?step=1`)
            } else {
              navigate(`/admin/colaboradores/atualizar/${uuid}`)
            }
          }}
        >
          voltar
        </MDButton>
        <MDButton
          disabled={!allDocuments}
          type="submit"
          variant="gradient"
          color="dark"
          onClick={() => {
            if (user.profile !== 99) {
              if (!allDocuments) return toast.warn("Preecha com os documentos obrigatórios");

              navigate(`/admin/colaboradores/atualizar/${uuid}?step=3`)
            } else {
              navigate(`/admin/colaboradores/atualizar/${uuid}?step=2`)
            }
          }}
        >
          próximo
        </MDButton>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for CooperatedDocumentsSecond
CooperatedDocumentsSecond.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
